import { DEFAULT_LOCALE, setLocale } from "@devforce/trailhead-client-locale";
import { createContextAdapter } from "common/context";
import { getAssetsUrl, setAssetsUrl } from "common/environment";

const ContextAdapter = createContextAdapter(
  () => {
    return {
      crossOriginAssets: process.env.CROSS_ORIGIN_ASSETS === "true",
      // See `rollup.config.js` for more explanation of this variable
      // If set, we trim everything after /modules to get the absolute assets url on `th-components`
      // If not, we default to the relative assets url on `th-components`
      assetsUrl: getAssetsUrl(),
      locale: getDefaultLocale(),
    };
  },
  {
    assetsUrl: "optional",
    crossOriginAssets: "optional",
    locale: "optional",
  }
); // eslint-disable-next-line @typescript-eslint/unbound-method

const { setDefaultValue } = ContextAdapter;
/**
 * th/contextAdapter is now deprecated
 * Any networking calls needing "apiHost" or "csrf" should use
 * @devforce/trailhead-client-api
 */

function setGlobalContext(context) {
  ContextAdapter.setGlobalContext(context);
  if (!context) return; // Forward global assetsUrl context to common/environment

  if (context.assetsUrl) {
    setAssetsUrl(context.assetsUrl);
  } // Forward global locale context to @devforce/trailhead-client-locale

  if (context.locale) {
    setLocale(context.locale);
  }
}

function getDefaultLocale() {
  // @ts-ignore
  return window.locale || DEFAULT_LOCALE;
}

export { ContextAdapter, setDefaultValue, setGlobalContext };
